<template>
  <BaseModal
    name="addMarkModal"
    width="420"
    :clickToClose="false"
    :shiftY="0.5"
    @before-close="beforeClose"
    @before-open="loadData"
    :adaptive="true"
    height="auto"
    classes="!tw-bg-transparent !tw-shadow-none"
  >
    <div
      class="tw-bg-white tw-rounded-[25px] tw-py-[38px] tw-px-[30px] tw-relative tw-text-forTitle"
      :style="{}"
    >
      <BaseLoader v-if="localLoading" class="tw-rounded-[25px]"></BaseLoader>
      <button
        type="button"
        class="btn-close tw-absolute tw-right-[30px] tw-top-[20px] !tw-shadow-none"
        @click="$modal.hide('addMarkModal')"
      ></button>
      <div class="tw-text-center">
        <div
          class="tw-text-center tw-text-[23px] tw-mb-[15px]"
          v-if="!dataForEmit.vehicle_marks__id"
        >
          Добавить новую марку
        </div>
        <div
          class="tw-text-center tw-text-[23px] tw-mb-[15px]"
          v-if="dataForEmit.vehicle_marks__id"
        >
          Редактирование марки
        </div>
        <div ref="vehicle_marks__name" class="wp-100">
          <BaseInputNew
            inputClass="tw-app-input-type-2"
            placeholder=""
            class="lh-1 wp-100"
            input-name="vehicle_marks__name"
            signClass="d-flex "
            @input="updateValue"
            openDirection="bottom"
            :horizontalTitle="true"
            :value="dataForEmit.vehicle_marks__name"
            :additionalParams="{}"
            name-sign=""
          />
          <div class="text-danger fsc-11 mt-10" v-if="errorMessage">
            {{ errorMessage }}
          </div>
        </div>
        <div
          class="d-flex mt-10 gap-10 align-items-center justify-content-center fsc-14"
        >
          Лого обзор
          <label class="d-flex align-items-center justify-content-center">
            <div
              style="width: 65px; height: 65px; flex-shrink: 0"
              v-if="loadedImage"
              class="responsive-image"
            >
              <img :src="loadedImage" class="wp-100 h-100" alt="" />
            </div>
            <input
              type="file"
              class="d-none"
              @change="(e) => uploadFile(e, 'vehicle_marks__logo')"
            />
            <div
              class="text-decoration-underline cursor-pointer"
              v-if="!loadedImage"
            >
              Загрузить
            </div>
          </label>
          <div
            class="text-decoration-underline cursor-pointer"
            v-if="loadedImage"
            @click="() => delFile('vehicle_marks__logo')"
          >
            Удалить
          </div>
        </div>
        <div class="tw-flex tw-gap-[10px] tw-mt-[15px] tw-justify-center">
          <button
            class="tw-app-btn-muted tw-app-btn-muted-lg"
            @click="$modal.hide('addMarkModal')"
          >
            {{ dataLang["reg_fin_text_57"] }}
          </button>
          <button
            @click="sendData"
            class="tw-app-btn-primary tw-app-btn-primary-lg"
          >
            {{ dataLang["reg_fin_text_58"] }}
          </button>
        </div>
      </div>
    </div>
  </BaseModal>
</template>

<script>
import { mapActions, mapState, mapMutations } from "vuex";
import GeneralService from "@/api/GeneralService.js";
import { VeTable } from "vue-easytable";
import EventBus from "@/event-bus.js";
import StorageFileService from "@/api/StorageFileService";

// TODO Сделать тестовую модалку с евентбасом, рефом, открытием по ссылке https://webdevblog.ru/vue-js-kak-ya-vyzyvaju-metod-v-komponente-izvne-komponenta-v-vue-2/
export default {
  components: {
    VeTable,
  },

  props: {},
  data() {
    return {
      loadedImage: "",
      errorMessage: "",
      localLoading: false,
      typeOperation: "",
      dataForEmit: {},
      updatedValues: {},
      currentId: null,
      loadCallback: null,
    };
  },
  methods: {
    loadData({ params }) {
      this.currentId = params?.id;
      if (params?.data) {
        this.dataForEmit = params?.data;
        this.loadedImage = this.dataForEmit?.vehicle_marks__logo;
      }
      if (params?.callback) {
        this.loadCallback = params?.callback;
      }
    },
    beforeClose(event) {
      this.dataForEmit = {};
      this.currentId = null;
      this.loadedImage = "";
      this.loadCallback = null;
      this.updatedValues = {};
    },
    updateValue(data) {
      this.dataForEmit[data.name] = data.value;
      this.updatedValues[data.name] = data.value;

      if (this.$refs[data.name]) {
        this.$refs[data.name].classList.remove("input-error");
      }
    },
    selectedRowChange({ row, isSelected, selectedRowKeys }) {
      this.activeSelectRowsMultiple = selectedRowKeys;
    },
    uploadFile(e, key) {
      let formData = new FormData();
      formData.append("file", e.target.files[0]);
      formData.append("type", "default");
      StorageFileService.upload(formData)
        .then((data) => {
          this.loadedImage = data.data.data.url;
          this.updateValue({ name: key, value: data.data.data.id });
        })
        .catch((err) => {});
    },

    delFile(name, file) {
      this.updateValue({ name: name, value: "" });
      this.loadedImage = "";
    },
    sendData() {
      this.localLoading = true;
      if (!this.currentId) {
        GeneralService.editOrCreate(`/marks`, {
          ...this.updatedValues,
        })
          .then((data) => {
            this.$toast.success(data.data.message);

            if (this.loadCallback) {
              this.loadCallback(data.data, this.updatedValues);
            }
            this.dataForEmit = {};
            this.updatedValues = {};
            this.$modal.hide("addMarkModal");
          })
          .catch((e) => {
            if (e?.response?.data) {
              this.$toast.error(e.response.data.message, { duration: 5000 });
            } else {
              console.error(e);
              this.$toast.error(e, { duration: 5000 });
            }
            if (e.response?.data?.errors) {
              setTimeout(() => {
                Object.keys(e.response.data.errors).forEach((elem, index) => {
                  if (this.$refs[elem]) {
                    this.$refs[elem].classList.add("input-error");
                  }
                });
              }, 10);
            }
          })
          .finally(() => {
            this.localLoading = false;
          });
      } else {
        GeneralService.edit(`/marks/${this.currentId}`, {
          ...this.updatedValues,
        })
          .then((data) => {
            this.$toast.success(data.data.message);
            if (this.loadCallback) {
              this.loadCallback(data.data);
            }
            this.dataForEmit = {};
            this.updatedValues = {};
            this.$modal.hide("addMarkModal");
          })
          .catch((e) => {
            this.$toast.error(e.response.data.message, { duration: 5000 });
            if (e.response?.data?.errors) {
              setTimeout(() => {
                Object.keys(e.response.data.errors).forEach((elem, index) => {
                  if (this.$refs[elem]) {
                    this.$refs[elem].classList.add("input-error");
                  }
                });
              }, 10);
            }
          })
          .finally(() => {
            this.localLoading = false;
          });
      }
    },
  },
  mounted() {},
  created() {},
  beforeDestroy() {},

  computed: {
    ...mapState("translationModule", ["dataLang"]),
  },
};
</script>
